import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=106c6d5d&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"
import style0 from "./VideoBlock.vue?vue&type=style&index=0&id=106c6d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c6d5d",
  null
  
)

export default component.exports